import { render } from "./AddProduitConditionnementPage.vue?vue&type=template&id=0b87de85&ts=true"
import script from "./AddProduitConditionnementPage.vue?vue&type=script&lang=ts"
export * from "./AddProduitConditionnementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__